import React from 'react';
import propTypes from 'prop-types';
export const SuitcaseIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 511.999 511.999"
      enableBackground="new 0 0 511.999 511.999"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path
              d="M171.758,207.074c-4.495,0-8.139,3.644-8.139,8.139v181.809c0,4.495,3.644,8.139,8.139,8.139
				c4.495,0,8.139-3.644,8.139-8.139V215.213C179.897,210.718,176.253,207.074,171.758,207.074z"
            />
            <path
              d="M255.999,116.728c-13.951,0-27.192,2.365-37.284,6.66c-16.598,7.063-19.077,16.814-19.077,21.998
				c0,18.814,28.353,28.658,56.361,28.658c13.949,0,27.19-2.366,37.282-6.66c16.597-7.063,19.076-16.814,19.076-21.998
				C312.358,126.572,284.006,116.728,255.999,116.728z M255.999,157.766c-26.301,0-40.083-9.199-40.083-12.38
				s13.782-12.38,40.083-12.38c26.299,0,40.081,9.198,40.081,12.38C296.08,148.568,282.299,157.766,255.999,157.766z"
            />
            <path
              d="M369.529,55.698H306.26V41.244c8.86-0.968,15.778-8.491,15.778-17.603v-5.927C322.039,7.947,314.092,0,304.324,0h-96.652
				c-9.767,0-17.714,7.947-17.714,17.715v5.927c0,9.114,6.92,16.636,15.78,17.603v14.453h-63.269
				c-23.345,0-42.337,18.992-42.337,42.337v346.401c0,20.983,15.349,38.441,35.406,41.76l10.9,21.364
				c1.39,2.725,4.191,4.44,7.25,4.44h14.945c3.059,0,5.86-1.716,7.25-4.441l10.606-20.787h139.02l10.605,20.787
				c1.39,2.725,4.19,4.441,7.25,4.441h14.945c3.059,0,5.859-1.716,7.25-4.441l10.899-21.363
				c20.058-3.319,35.408-20.777,35.408-41.761v-346.4C411.867,74.691,392.873,55.698,369.529,55.698z M207.673,16.278h96.652
				c0.765,0,1.436,0.672,1.436,1.437v5.927c0,0.765-0.671,1.436-1.436,1.436h-5.261c-2.582,0-4.963,1.22-6.479,3.211
				c-1.959-1.358-4.214-2.087-6.602-2.087c-2.762,0-5.344,0.974-7.495,2.767c-2.152-1.792-4.735-2.767-7.495-2.767
				s-5.342,0.973-7.495,2.768c-2.152-1.793-4.735-2.768-7.497-2.768c-2.761,0-5.342,0.974-7.495,2.768
				c-2.152-1.793-4.735-2.768-7.497-2.768c-2.761,0-5.344,0.974-7.495,2.768c-2.152-1.793-4.736-2.768-7.497-2.768
				c-2.387,0-4.641,0.729-6.601,2.088c-1.515-1.991-3.897-3.211-6.479-3.211h-5.262c-0.765,0-1.436-0.671-1.436-1.436v-5.928h-0.001
				C206.238,16.95,206.908,16.278,207.673,16.278z M289.984,47.278v8.42h-67.966v-8.42c1.438-0.463,2.787-1.201,3.998-2.209
				c2.152,1.792,4.735,2.767,7.497,2.767c2.76,0,5.341-0.973,7.495-2.768c2.152,1.793,4.736,2.768,7.497,2.768
				c2.76,0,5.342-0.974,7.495-2.768c2.152,1.793,4.735,2.768,7.497,2.768c2.761,0,5.344-0.974,7.495-2.768
				c2.152,1.793,4.735,2.768,7.497,2.768c2.759,0,5.34-0.973,7.494-2.768C287.193,46.075,288.543,46.815,289.984,47.278z
				 M163.65,495.722h-4.976l-4.567-8.95h14.108L163.65,495.722z M353.325,495.722h-4.976l-4.565-8.95h14.107L353.325,495.722z
				 M369.529,470.494H142.47c-11.527,0-21.323-7.526-24.75-17.92h276.56C390.853,462.969,381.056,470.494,369.529,470.494z
				 M395.589,436.297H116.411V98.035c0-14.369,11.69-26.059,26.059-26.059h227.058c14.369,0,26.06,11.69,26.06,26.059V436.297z"
            />
            <path
              d="M340.239,207.074c-4.496,0-8.139,3.644-8.139,8.139v181.809c0,4.495,3.643,8.139,8.139,8.139
				c4.496,0,8.139-3.644,8.139-8.139V215.213C348.378,210.718,344.735,207.074,340.239,207.074z"
            />
            <path
              d="M213.879,207.074c-4.495,0-8.139,3.644-8.139,8.139v181.809c0,4.495,3.644,8.139,8.139,8.139
				c4.495,0,8.139-3.644,8.139-8.139V215.213C222.018,210.718,218.373,207.074,213.879,207.074z"
            />
            <path
              d="M255.998,207.074c-4.495,0-8.139,3.644-8.139,8.139v181.809c0,4.495,3.644,8.139,8.139,8.139
				c4.496,0,8.139-3.644,8.139-8.139V215.213C264.137,210.718,260.494,207.074,255.998,207.074z"
            />
            <path
              d="M298.119,207.074c-4.496,0-8.139,3.644-8.139,8.139v181.809c0,4.495,3.643,8.139,8.139,8.139s8.139-3.644,8.139-8.139
				V215.213C306.258,210.718,302.614,207.074,298.119,207.074z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
SuitcaseIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
SuitcaseIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
